import React, { useRef } from "react";
import SideBar from "./SideBar";
import TopBar from "./TopBar";
import upload from "../Assets/imgs/upload.svg";
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { useTranslation } from "react-i18next";
import { DateField } from "./aces/DateField";
import { ChecklistContextFields, QuestionControlFields, initialContext, useActiveCatalogue } from "./aces/ChecklistContextFields";

interface Props {
  onSubmit: (values: any) => Promise<void>;
  defaultValues?: any;
  isTemplate: boolean;
  edit?: boolean;
}
const ChecklistSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
});
const NewChecklist = ({ onSubmit, defaultValues, isTemplate, edit }: Props) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();
  const catalogue = useActiveCatalogue();

  return (
    <div className="__dashboard">
      <div className="__dashboard__wrapper">
        <SideBar />
        <div className="__dashboardRightSide">
          <TopBar />
          <div className="__dashboardContent">
            <div className="__pageHeading">
              {isTemplate ? (
                <>
                  {edit
                    ? t("checklistForm.editTemplate")
                    : t("checklistForm.newTemplate")}
                </>
              ) : (
                t("checklistForm.newChecklist")
              )}
            </div>
            <div
              className="__myTraining"
              style={{ paddingLeft: "40px", paddingRight: "40px" }}
            >
              <Formik
                initialValues={{
                  title: defaultValues?.title || "",
                  description: defaultValues?.description || "",
                  duaDateTime: "",
                  priority: defaultValues?.priority || "",
                  emailReminder: defaultValues?.emailReminder || false,
                  attachment: [],
                  context: initialContext(defaultValues),

                  data: {
                    manager: defaultValues?.data?.manager?.map((m: any) => ({
                      title: m.title || "",
                      answer: m.answer || "",
                      // note: m.note || "",
                    })) || [
                      {
                        title: "",
                        answer: "",
                        // note: "",
                      },
                    ],
                    employee: defaultValues?.data?.employee?.map((e: any) => ({
                      title: e.title || "",
                      // isImage: e.isImage ?? true,
                      note: e.note || "",
                      requirementText: e.requirementText || "",
                      acesClauseId: e.acesClauseId ? String(e.acesClauseId) : "",
                    })) || [
                      {
                        title: "",
                        answer: "",
                        // isImage: true,
                        note: "",
                      },
                    ],
                  },
                }}
                validationSchema={ChecklistSchema}
                onSubmit={onSubmit}
              >
                {({ values, setFieldValue, handleChange, errors, touched }) => (
                  <Form>
                    <div className="__inputField">
                      <label htmlFor="">
                        {t("checklistForm.title")}{" "}
                        <span style={{ color: "red" }}> *</span>
                      </label>
                      <Field type="text" name="title" />
                      {errors.title && touched.title && (
                        <div className="error">{errors.title as string}</div>
                      )}
                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <label htmlFor="">
                          {t("checklistForm.description")}
                          <span style={{ color: "red" }}> *</span>
                        </label>
                      </div>
                      <div className="col-lg-6">
                        <div className="__inputField textarealength">
                          <Field
                            as="textarea"
                            name="description"
                            placeholder={t("placeholders.type_here")}
                            maxLength={20}
                          />
                        </div>
                      </div>
                    </div>
                    {!isTemplate && (
                      <div className="row">
                        <div className="col-lg-6  col-md-6">
                          <div className="__inputField">
                            <label
                              htmlFor="checklist-due-date"
                              style={{ color: "red", fontWeight: "600" }}
                            >
                              {t("checklistForm.dueDate")}{" "}
                              <span style={{ color: "red" }}> *</span>
                            </label>
                            <Field name="duaDateTime">
                              {({ field, form }: any) => (
                                <DateField
                                  id="checklist-due-date"
                                  withTime
                                  className=""
                                  value={field.value}
                                  onChange={(v) => form.setFieldValue("duaDateTime", v)}
                                  onBlur={() => form.setFieldTouched("duaDateTime", true)}
                                />
                              )}
                            </Field>
                            {errors.duaDateTime && touched.duaDateTime && (
                              <div className="error">
                                {errors.duaDateTime as string}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6  col-md-6">
                          <div className="__inputField">
                            <label htmlFor="">
                              {t("checklistForm.priority")}{" "}
                              <span style={{ color: "red" }}> *</span>
                            </label>
                            <Field as="select" name="priority">
                              <option value="">
                                {t("checklistForm.select")}
                              </option>
                              <option value="High">
                                {t("checklistForm.high")}
                              </option>
                              <option value="Medium">
                                {t("checklistForm.medium")}
                              </option>
                              <option value="Low">
                                {t("checklistForm.low")}
                              </option>
                            </Field>
                            {errors.priority && touched.priority && (
                              <div className="error">
                                {errors.priority as string}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    <ChecklistContextFields isTemplate={!!isTemplate} />
                    <div className="row">
                      <div className="col-lg-6">
                        <label>
                          {t("checklistForm.questions")}{" "}
                          <span style={{ color: "red" }}> *</span>
                        </label>
                      </div>
                      <div className="col-lg-6">
                        <div className="__inputField">
                          {/* Manager Section */}
                          <h5>
                            {/* {t("checklistForm.managerSection")}
                             */}
                            {t("shipment.details")}
                            <span style={{ color: "red" }}> *</span>{" "}
                          </h5>
                          <FieldArray name="data.manager">
                            {({ push, remove }) => (
                              <>
                                {values.data.manager.map(
                                  (item: any, index: number) => (
                                    <div key={index} className="mb-3">
                                      <div className="flex-gap mb-2">
                                        {/* Question Title (editable in template, read-only otherwise) */}
                                        {isTemplate ? (
                                          <input
                                            type="text"
                                            // placeholder={`Manager Question ${
                                            //   index + 1
                                            // }`}
                                            placeholder={t(
                                              "placeholders.manager_question",
                                              { index: index + 1 }
                                            )}
                                            name={`data.manager[${index}].title`}
                                            value={item.title}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                          />
                                        ) : (
                                          <input
                                            type="text"
                                            value={item.title}
                                            className="form-control"
                                            readOnly
                                          />
                                        )}

                                        {/* Answer (only shown when isTemplate is false) */}
                                        {!isTemplate && (
                                          <input
                                            type="text"
                                            // placeholder="Answer"
                                            placeholder={t(
                                              "placeholders.answer"
                                            )}
                                            name={`data.manager[${index}].answer`}
                                            value={item.answer}
                                            onChange={handleChange}
                                            className="form-control"
                                          />
                                        )}

                                        {/* Remove Button (optional: hide in non-template mode) */}
                                        {isTemplate && (
                                          // <div
                                          //   className="addItem_btn"
                                          //   onClick={() => remove(index)}
                                          // >
                                          //   Remove
                                          // </div>
                                          <div
                                            className="addItem_btn"
                                            onClick={() => remove(index)}
                                          >
                                            {t("checklistForm.remove")}
                                          </div>
                                        )}
                                      </div>

                                      {/* Note field (optional) */}
                                      {/* <input
                                        type="text"
                                        // placeholder="Note (optional)"
                                        placeholder={t(
                                          "placeholders.note_optional"
                                        )}
                                        name={`data.manager[${index}].note`}
                                        value={item.note}
                                        onChange={handleChange}
                                        className="form-control mt-1"
                                      /> */}
                                    </div>
                                  )
                                )}

                                {/* Add button (only in template mode) */}
                                {isTemplate && (
                                  <div
                                    className="addItem_btn mt-2"
                                    onClick={() =>
                                      push({ title: "", answer: ""})

                                      // push({ title: "", answer: "", note: "" })

                                    }
                                  >
                                    + {t("checklistForm.addQuestion")}
                                  </div>
                                )}
                              </>
                            )}
                          </FieldArray>

                          <hr className="my-4" />

                          {/* Employee Section */}
                          <h5>
                            {/* {t("checklistForm.employeeSection")} */}
                            {t("shipment.questions")}
                            <span style={{ color: "red" }}> *</span>
                          </h5>
                          <FieldArray name="data.employee">
                            {({ push, remove }) => (
                              <>
                                {values.data.employee.map(
                                  (item: any, index: number) => (
                                    <div
                                      key={index}
                                      className="mb-3 border p-3 rounded"
                                    >
                                      {/* Question Title */}
                                      <div className="flex-gap mb-2">
                                        <input
                                          type="text"
                                          // placeholder={`Employee Question ${
                                          //   index + 1
                                          // }`}
                                          placeholder={t(
                                            "placeholders.employee_question",
                                            { index: index + 1 }
                                          )}
                                          name={`data.employee[${index}].title`}
                                          value={item.title}
                                          onChange={handleChange}
                                          className="form-control"
                                          required
                                        />
                                        <div
                                          className="addItem_btn"
                                          onClick={() => remove(index)}
                                          style={{ height: "40px" }}
                                        >
                                          {t("checklistForm.remove")}
                                        </div>
                                      </div>

                                      {/* isImage Checkbox */}
                                      {/* <div className="form-check mb-2 flex-gap">
                                        <input
                                          className="form-check-input checkBoxInput"
                                          type="checkbox"
                                          id={`employee_isImage_${index}`}
                                          name={`data.employee[${index}].isImage`}
                                          checked={item.isImage}
                                          onChange={() =>
                                            setFieldValue(
                                              `data.employee[${index}].isImage`,
                                              !item.isImage
                                            )
                                          }
                                        />
                                        <label className="form-check-label mb-0">
                                          {t("checklistForm.isImageRequired")}
                                        </label>
                                      </div> */}

                                      {/* Optional Note */}
                                      <input
                                        type="text"
                                        // placeholder="Note (optional)"
                                        placeholder={t(
                                          "placeholders.note_optional"
                                        )}
                                        name={`data.employee[${index}].note`}
                                        value={item.note}
                                        onChange={handleChange}
                                        className="form-control"
                                      />
                                      <QuestionControlFields prefix={`data.employee[${index}]`} catalogue={catalogue} />
                                    </div>
                                  )
                                )}

                                {/* Add Question Button */}
                                <div
                                  className="addItem_btn mt-2"
                                  onClick={() =>
                                    push({
                                      title: "",
                                      // isImage: false,
                                      note: "",
                                    })
                                  }
                                >
                                  + {t("checklistForm.addQuestion")}
                                </div>
                              </>
                            )}
                          </FieldArray>
                        </div>
                      </div>
                    </div>

                    {!isTemplate && (
                      <div className="__inputField">
                        <label htmlFor="">
                          {t("checklistForm.attachmentOptional")}
                        </label>
                        <div className="upload-wrapper">
                          <button
                            type="button"
                            className="upload-button"
                            onClick={() => fileInputRef.current?.click()}
                          >
                            <span>
                              <img src={upload} alt="upload" />
                            </span>
                            {t("checklistForm.uploadFile")}
                          </button>
                          <input
                            type="file"
                            multiple
                            accept="image/*,application/pdf"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={(e) => {
                              const files = Array.from(
                                e.currentTarget.files || []
                              );
                              const validFiles = files.filter(
                                (file) =>
                                  file.type.startsWith("image/") ||
                                  file.type === "application/pdf"
                              );
                              if (validFiles.length !== files.length) {
                                alert("Only image and PDF files are allowed.");
                              }
                              // Merge with existing files (to allow multiple selections in steps)
                              setFieldValue("attachment", [
                                ...values.attachment,
                                ...validFiles,
                              ]);
                            }}
                          />

                          {/* 📝 Display list of selected files */}
                          <div
                            className="attachment-preview-list"
                            style={{ marginTop: "10px" }}
                          >
                            {Array.isArray(values.attachment) &&
                              values.attachment.length > 0 &&
                              values.attachment.map(
                                (file: File, index: number) => (
                                  <div
                                    key={index}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      padding: "6px 10px",
                                      backgroundColor: "#f4f4f4",
                                      borderRadius: "6px",
                                      marginBottom: "5px",
                                      paddingTop: "10px",
                                      paddingBottom: "10px",
                                      paddingLeft: "10px",
                                    }}
                                  >
                                    <span>{file.name}</span>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        const updated =
                                          values.attachment.filter(
                                            (_, i) => i !== index
                                          );
                                        setFieldValue("attachment", updated);
                                      }}
                                      style={{
                                        background: "transparent",
                                        border: "none",
                                        fontSize: "16px",
                                        cursor: "pointer",
                                        color: "#ff4d4f",
                                      }}
                                    >
                                      ❌
                                    </button>
                                  </div>
                                )
                              )}
                          </div>
                        </div>
                      </div>
                    )}

                    {!isTemplate && (
                      <div className="__inputField ">
                        <label htmlFor="">{t("checklistForm.reminder")}</label>
                        <div className="visibilityInputField">
                          <Field type="checkbox" name="emailReminder" />
                          <span>
                            {t("checklistForm.enableEmailReminder")}
                            <span style={{ color: "red" }}> *</span>
                          </span>
                        </div>
                      </div>
                    )}

                    <div className="create_Checklist">
                      <button type="submit">
                        {/* {!isTemplate ? (
                          "Create Checklist"
                        ) : (
                          <>{edit ? "Edit Template" : "Add Template"}</>
                        )} */}
                        {!isTemplate
                          ? t("checklistForm.createChecklist")
                          : edit
                          ? t("checklistForm.editTemplate")
                          : t("checklistForm.addTemplate")}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewChecklist;
